<template>
    <div class="bg-white rounded box-shadow p-3">
        <b-modal hide-footer id="add-tree-rate-modal" size="lg" title="Tree Rate">
            <div class="row">
                <div class="col-md-12">
                    <div class="alert alert-danger alert-dismissible fade show" role="alert" v-if="show">
                        <span :key="index" v-for="(err, index) in validation_errors">
                          {{ err[0] }} <br/>
                        </span>
                    </div>
                </div>
            </div>
            <div class="modal-content bg-white rounded box-shadow">
                <div class="form-row">
                    <div class="col-md-6 col-sm-6 col-lg-4">
                        <label for="upazila_id">Upazila <span class="c-required">*</span></label>
                        <select v-model="tree_rate_data.upazila_id" v-validate="'required'" class="form-control form-control-sm" name="upazila_id" id="upazila_id">
                            <option selected :value="''">Select a Upazila</option>
                            <option v-for="(upazila, index) in upazilas" :key="index" :value="upazila.id">{{upazila.id}} : {{ upazila.upazila_desc }}</option>
                        </select>
                        <div class="invalid-feedback">Please select upazila</div>
                    </div>
                    <div class="col-md-6 col-sm-6 col-lg-4">
                        <label for="tree_name_id">Tree <span class="c-required">*</span></label>
                        <select v-model="tree_rate_data.tree_name_id" v-validate="'required'" class="form-control form-control-sm" name="tree_name_id" id="tree_name_id">
                            <option selected :value="''">Select a Tree</option>
                            <option v-for="(tree_name, index) in tree_names" :key="index" :value="tree_name.id">{{tree_name.id}} : {{ tree_name.tree_name_desc }}</option>
                        </select>
                        <div class="invalid-feedback">Please select tree</div>
                    </div>
                    <div class="col-md-6 col-sm-6 col-lg-4">
                    <label for="dc_rate_large">DC Rate(Large) <span class="c-required">*</span></label>
                    <input type="number" v-model="tree_rate_data.dc_rate_large" v-validate="{ required: true, regex: /^[0-9]*(?:\.[0-9]{0,2})?$/ }" id="dc_rate_large" name="dc_rate_large" placeholder="DC rate large" class="form-control form-control-sm"/>
                    <div class="invalid-feedback">DC Rate large is required and with numeric number</div>
                  </div>
                </div>
                <div class="form-row mt-2">
                    <div class="col-md-6 col-sm-6 col-lg-4">
                        <label  for="dc_rate_medium">DC Rate(Medium) <span class="c-required">*</span></label>
                        <input type="number" v-model="tree_rate_data.dc_rate_medium" v-validate="{ required: true, regex: /^[0-9]*(?:\.[0-9]{0,2})?$/ }" id="dc_rate_medium" name="dc_rate_medium" class="form-control form-control-sm" placeholder="DC rate medium"/>
                        <div class="invalid-feedback">DC Rate medium is required and with numeric number</div>
                    </div>
                    <div class="col-md-6 col-sm-6 col-lg-4">
                      <label for="dc_rate_small">DC Rate(Small) <span class="c-required">*</span></label>
                      <input type="number" v-model="tree_rate_data.dc_rate_small" v-validate="{ required: true, regex: /^[0-9]*(?:\.[0-9]{0,2})?$/ }" id="dc_rate_small" name="dc_rate_small" placeholder="DC rate small" class="form-control form-control-sm"/>
                      <div class="invalid-feedback">DC Rate small is required and with numeric number</div>
                    </div>
                  <div class="col-md-6 col-sm-6 col-lg-4">
                    <label for="dc_rate_saplings">DC Rate(Small) <span class="c-required">*</span></label>
                    <input type="number" v-model="tree_rate_data.dc_rate_saplings" v-validate="{ required: true, regex: /^[0-9]*(?:\.[0-9]{0,2})?$/ }" id="dc_rate_saplings" name="dc_rate_saplings" placeholder="DC rate saplings" class="form-control form-control-sm"/>
                    <div class="invalid-feedback">DC Rate sapling is required and with numeric number</div>
                  </div>
                </div>
                <div class="form-row mt-2">
                  <div class="col-md-6 col-sm-6 col-lg-4">
                    <label  for="pvac_rate_large">PVAC Rate(Large) <span class="c-required">*</span></label>
                    <input type="number" v-model="tree_rate_data.pvac_rate_large" v-validate="{ required: true, regex: /^[0-9]*(?:\.[0-9]{0,2})?$/ }" id="pvac_rate_large" name="pvac_rate_large" class="form-control form-control-sm" placeholder="PVAC rate large"/>
                    <div class="invalid-feedback">PVAC rate large is required and with numeric number</div>
                  </div>
                  <div class="col-md-6 col-sm-6 col-lg-4">
                    <label for="pvac_rate_medium">PVAC Rate(Medium) <span class="c-required">*</span></label>
                    <input type="number" v-model="tree_rate_data.pvac_rate_medium" v-validate="{ required: true, regex: /^[0-9]*(?:\.[0-9]{0,2})?$/ }" id="pvac_rate_medium" name="pvac_rate_medium" placeholder="PVAC rate medium" class="form-control form-control-sm"/>
                    <div class="invalid-feedback">DC Rate medium is required and with numeric number</div>
                  </div>
                  <div class="col-md-6 col-sm-6 col-lg-4">
                    <label for="pvac_rate_small">PVAC Rate(Small) <span class="c-required">*</span></label>
                    <input type="number" v-model="tree_rate_data.pvac_rate_small" v-validate="{ required: true, regex: /^[0-9]*(?:\.[0-9]{0,2})?$/ }" id="pvac_rate_small" name="pvac_rate_small" placeholder="PVAC rate small" class="form-control form-control-sm"/>
                    <div class="invalid-feedback">PVAC Rate small is required and with numeric number</div>
                  </div>
                </div>
              <div class="form-row mt-2">
                  <div class="col-md-6 col-sm-6 col-lg-4">
                    <label  for="pvac_rate_saplings">PVAC Rate(Sampling) <span class="c-required">*</span></label>
                    <input type="number" v-model="tree_rate_data.pvac_rate_saplings" v-validate="{ required: true, regex: /^[0-9]*(?:\.[0-9]{0,2})?$/ }" id="pvac_rate_saplings" name="pvac_rate_saplings" class="form-control form-control-sm" placeholder="PVAC rate sampling"/>
                    <div class="invalid-feedback">PVAC rate sampling is required and with numeric number</div>
                  </div>
                </div>
                <div class="form-row mt-3 mb-3">
                    <div class="float-right">
                        <b-button v-if="!this.btn_edit" class="form-control-sm mr-2" size="sm" variant="success" @click.prevent="save">Save</b-button>
                        <b-button v-if="this.btn_edit" class="form-control-sm mr-2" size="sm" variant="warning" @click.prevent="update">Update</b-button>
                        <b-button class="form-control-sm" size="sm" variant="danger" @click="$bvModal.hide('add-tree-rate-modal')">Cancel</b-button>
                    </div>
                </div>
            </div>
        </b-modal>
    </div>
</template>

<script>
    import http from "@state/http";

    export default {
        name: "addTreeRateModal",
        props: ["tree_rate_data", "upazilas", "tree_names", "btn_edit"],
        data() {
            return {
                errorMessage: "",
                status: 0,
                message: "",
                validation_errors: {},
                show: false,
            };
        },

        mounted() {
        },
        methods: {
            save() {
                this.$validator.validate().then(valid => {
                    if (valid) {
                        http
                            .post("api/rate/trees", this.tree_rate_data)
                            .then(response => {
                                if (!response.data.error) {
                                    this.$bvToast.toast(response.data.message, {
                                        title: "Success",
                                        autoHideDelay: 5000,
                                        variant: "success"
                                    });
                                    this.$bvModal.hide("add-tree-rate-modal");
                                    this.$emit("search");
                                }
                            })
                            .catch(error => {
                                this.validation_errors = error.response.data.errors;
                                this.show = true;
                                this.hide();
                            });
                    }
                });
            },
            update() {
                this.$validator.validate().then(valid => {
                    if (valid) {
                        http
                            .put("api/rate/trees/" + this.tree_rate_data.id, this.tree_rate_data)
                            .then(response => {
                                if (!response.data.error) {
                                    this.$bvToast.toast(response.data.message, {
                                        title: "Success",
                                        autoHideDelay: 5000,
                                        variant: "success"
                                    });
                                    this.$bvModal.hide("add-tree-rate-modal");
                                    this.$emit("search");
                                }
                            })
                            .catch(error => {
                                this.validation_errors = error.response.data.errors;
                                this.show = true;
                                this.hide();
                            });
                    }
                });
            },
            hide() {
                setTimeout(() => {
                    this.show = false;
                }, 5000);
            },
        },
    };
</script>
